import { render, staticRenderFns } from "./WidgetSelector.vue?vue&type=template&id=3ad9bd09&scoped=true&"
import script from "./WidgetSelector.vue?vue&type=script&lang=js&"
export * from "./WidgetSelector.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSelector.vue?vue&type=style&index=0&id=3ad9bd09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad9bd09",
  null
  
)

export default component.exports